import { FC } from 'react';

interface LoaderProps {
  loading: boolean;
}

const Loader: FC<LoaderProps> = ({ loading }) => {
  if (!loading) {return null;}

  return (
    <>
      <div id="overlay">
        <div className="spinner d-flex justify-content-center">
          <img
            className="loader-img"
            alt="InnoRise"
            src={require('../assets/images/innoriseLoader.gif')}
          />
        </div>
      </div>
    </>
  );
};

export default Loader;
